import { render, staticRenderFns } from "./QuestionTypeFreeTextVideo.vue?vue&type=template&id=5ac99c71"
import script from "./QuestionTypeFreeTextVideo.vue?vue&type=script&lang=js"
export * from "./QuestionTypeFreeTextVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports